import React, { useState, useContext } from "react";
import { Modal } from "react-bootstrap";
import { addAddressId, claimReward } from "../Services/Service.js";
import { useNavigate } from "react-router-dom";
const initialValue = {
  name: "",
  firstName: "",
  lastName: "",
  mobile: "",
  addressId: "",
  email: "",
  address: "",
  landmark: "",
  city: "",
  pinCode: "",
  state: "",
  isDefault: "N",
};

const RegisterWinModal = ({ isOpen, onClose, onSuccess }) => {
  const [user, setUser] = useState(initialValue);
  const [formErrors, setFormErrors] = useState("");
  const [checkedAdd, setCheckedAdd] = useState(false);
  const nav = useNavigate();
  function emailValidation() {
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!user.email || regex.test(user.email) === false) {
      setFormErrors("Email is invalid");
      return false;
    }
    return true;
  }

  const onValueChange = (e) => {
    // setCheckedAdd(!checkedAdd)
    if (e.target.name === "addressName") {
      // console.log(e.target.value)
      if (e.target.value.length >= 4) {
        setFormErrors("");
      } else {
        setFormErrors("Save Address alias, minimum 4 length");
      }
      setUser({ ...user, [e.target.name]: e.target.value });
    } else if (e.target.name === "mobile") {
      if (e.target.value.length <= 10) {
        if (e.target.name === "mobile" && e.target.value.length === 10) {
          setFormErrors("");
        } else {
          setFormErrors("Please Enter 10 digit mobile no");
        }
        setUser({ ...user, [e.target.name]: e.target.value });
      }
    } else if (e.target.name === "pinCode") {
      if (e.target.value.length <= 6) {
        if (e.target.name === "pinCode" && e.target.value.length === 6) {
          setFormErrors("");
        } else {
          setFormErrors("Please Enter 6 digit pinCode");
        }
        setUser({ ...user, [e.target.name]: e.target.value });
      }
    } else if (e.target.name === "address") {
      if (e.target.value.length <= 100) {
        if (e.target.name === "address" && e.target.value.length >= 10) {
          setFormErrors("");
        } else {
          setFormErrors("Please Enter 10 characters");
        }
        setUser({ ...user, [e.target.name]: e.target.value });
      }
    } else if (e.target.name === "landmark") {
      if (e.target.value.length <= 100) {
        if (e.target.name === "landmark" && e.target.value.length >= 10) {
          setFormErrors("");
        } else {
          setFormErrors("Please Enter 10 characters");
        }
        setUser({ ...user, [e.target.name]: e.target.value });
      }
    } else if (e.target.name === "state") {
      if (e.target.value.length <= 20) {
        if (e.target.name === "state" && e.target.value.length >= 3) {
          setFormErrors("");
        } else {
          setFormErrors("Please Enter state");
        }
        setUser({ ...user, [e.target.name]: e.target.value });
      }
    } else if (e.target.name === "city") {
      if (e.target.value.length <= 20) {
        if (e.target.name === "city" && e.target.value.length >= 3) {
          setFormErrors("");
        } else {
          setFormErrors("Please Enter city");
        }
        setUser({ ...user, [e.target.name]: e.target.value });
      }
    } else if (e.target.name === "email") {
      const data = emailValidation();
      if (data) {
        setFormErrors("");
        setUser({ ...user, [e.target.name]: e.target.value });
      } else {
        setUser({ ...user, [e.target.name]: e.target.value });
      }
    } else if (e.target.name === "isDefault") {
      // console.log(e.target.name, checkedAdd)
      setCheckedAdd(!checkedAdd);
      if (!checkedAdd) {
        // console.log(checkedAdd)
        setUser({ ...user, [e.target.name]: "Y" });
      } else {
        setUser({ ...user, [e.target.name]: "N" });
      }
    } else {
      // console.log(e.target.name,e.target.value)
      setUser({ ...user, [e.target.name]: e.target.value });
    }
  };

  function validateForm(e) {
    if (user.name.length < 4) {
      setFormErrors("Please Enter Name");
      return false;
    } else if (user.mobile.length !== 10) {
      setFormErrors("Please Enter 10 digit Mobile No.");
      return false;
    } else if (!emailValidation()) {
      setFormErrors("Please enter valid Email");
      return false;
    } else if (user.address.length < 10) {
      setFormErrors("Please Enter 10 characters in Address 1");
      return false;
    } else if (user.landmark.length < 10) {
      setFormErrors("Please Enter 10 characters in Landmark");
      return false;
    } else if (user.pinCode.length !== 6) {
      setFormErrors("Please Enter 6 digit pincode");
      return false;
    } else if (user.city.length < 3) {
      setFormErrors("Please Enter City");
      return false;
    } else if (user.state.length < 3) {
      setFormErrors("Please Enter State");
      return false;
    } else {
      setFormErrors("");
      return true;
    }
  }
  const submitHandle = async (e) => {
    e.preventDefault();

    const isValidForm = validateForm(e);
    if (!isValidForm) return;

    try {
      const response = await addAddressId(user);
      console.log(response.data.status);
      if (response?.data?.status == 1) {
        // onSuccess();
        // try {
        //   const res = await claimReward();
        //   console.log(res?.data?.data, "claim url");
        //   nav(`/track?order_id=${res?.data?.orderId}`);
        // } catch (error) {
        //   console.error("Failed to claim reward:", error);
        // } finally {
        // }\
        onClose();
      } else {
        console.error("Failed to add address:", response?.data?.message);
      }
    } catch (error) {
      console.error("Error while adding address:", error);
    } finally {
    }
  };
  if (!isOpen) return null;

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <h2 className="text-xl font-bold mb-0">Add Your Address</h2>
      </Modal.Header>
      <Modal.Body>
        <form action="" className="p-2">
          <label for="addressName" className="mt-2">
            <h4>Address Name</h4>
          </label>
          <input
            type="text"
            placeholder=""
            value={user.addressName}
            onChange={(e) => onValueChange(e)}
            name="addressName"
            className="input-1"
          />

          <label for="firstName" className="mt-2">
            <h4>
              First Name<span className="red-astrix">*</span>
            </h4>
          </label>
          <input
            type="text"
            placeholder=""
            value={user.name}
            onChange={(e) => onValueChange(e)}
            name="name"
            className="input-1"
          />

          <label for="mobile" className="mt-2">
            <h4>
              Mobile<span className="red-astrix">*</span>
            </h4>
          </label>
          <input
            type="number"
            placeholder=""
            name="mobile"
            value={user.mobile}
            onChange={(e) => onValueChange(e)}
            className="input-1"
          />

          <label for="email" className="mt-2">
            <h4>
              Email<span className="red-astrix">*</span>
            </h4>
          </label>
          <input
            type="email"
            placeholder="abc@example.com"
            value={user.email}
            onChange={(e) => onValueChange(e)}
            name="email"
            className="input-1 mt-2"
          />

          <label for="address" className="mt-2">
            <h4>
              Address<span className="red-astrix">*</span>
            </h4>
          </label>
          <input
            type="text"
            placeholder="Adress Line 1"
            name="address"
            value={user.address}
            onChange={(e) => onValueChange(e)}
            className="input-1"
          />
          <input
            type="text"
            placeholder="Adress Line 2"
            name="landmark"
            value={user.landmark}
            onChange={(e) => onValueChange(e)}
            className="input-1 mt-2"
          />
          <div className="adress-line-3">
            <input
              type="number"
              placeholder="PIN Code"
              name="pinCode"
              value={user.pinCode}
              maxLength={6}
              onChange={(e) => onValueChange(e)}
              className="input-1 mt-2"
            />
            <input
              type="text"
              placeholder="City"
              name="city"
              value={user.city}
              onChange={(e) => onValueChange(e)}
              className="input-1 mt-2"
            />
            <input
              type="text"
              placeholder="State"
              name="state"
              value={user.state}
              onChange={(e) => onValueChange(e)}
              className="input-1 mt-2"
            />
          </div>
          <div className="rowGap10" />
          <div className="form-outline mb-4">
            <input
              type="checkbox"
              id="isDefault"
              name="isDefault"
              value="Y"
              checked={checkedAdd}
              onChange={(e) => onValueChange(e)}
            />
            <label htmlFor="isDefault">&nbsp; Set as default Address</label>
          </div>
          {formErrors != "" ? (
            <div className={"alert alert-danger col-md-4"} role="alert">
              {formErrors}
            </div>
          ) : null}
          <button className="btn-icespice" onClick={(e) => submitHandle(e)}>
            {"Add Address"}
          </button>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default RegisterWinModal;
